// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1___17c3a58b6e69e04488b","cls2":"News-cls2___4c7937bc289751e768a News-cls1___17c3a58b6e69e04488b"};